const ENVIRONMENTS = {
  production: {
    BASE_URL: "https://apb.acrossassist.com",
    ROUTE_URL: "https://apb.acrossassist.com",
    API_URL: "https://portal.acrossassist.com/api/",
    STROKE_WIDTH: 30,
    SCREEN_COVERAGE_THRESHOLD: 99,
  },
  staging: {
    BASE_URL: "https://test3.acrossassist.in",
    ROUTE_URL: "https://test3.acrossassist.in",
    API_URL: "https://portal.acrossassist.com/api/",
    STROKE_WIDTH: 30,
    SCREEN_COVERAGE_THRESHOLD: 99,
  },
  development: {
    BASE_URL: "http://localhost:3000",
    ROUTE_URL: "http://localhost:3000",
    API_URL: "https://portal.acrossassist.com/api/",
    STROKE_WIDTH: 30,
    SCREEN_COVERAGE_THRESHOLD: 99,
  },
};

const getEnvironment = () => {
  const baseUrl = window.location.origin;
  if (baseUrl === ENVIRONMENTS.production.BASE_URL) {
    return "production";
  } else if (baseUrl === ENVIRONMENTS.staging.BASE_URL) {
    return "staging";
  } else if (baseUrl === ENVIRONMENTS.development.BASE_URL) {
    return "development";
  } else {
    // Default to development if not matched
    return "development";
  }
};

const CURRENT_ENV = getEnvironment();

export const URL_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
};
